<template>
    <div class="min-vh-100">
        <v-card class="min-vh-100" style="background-color: #F2F3F3">
            <v-card-title class="bg-primary w-100">
                <div class="d-flex justify-content-between w-100">
                    <div class="text-white d-flex">
                        <v-icon color="white">search</v-icon>
                        <h5 style="min-width: 400px; " class="ml-2">Identification de page Google MyBusiness</h5>
                    </div>

                    <div class="text-right w-100">
                        <v-btn icon dark @click="cancel">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-card-title>

            <v-card-text class="pl-0 pb-0 h-auto pr-0">
                <div class="container">
                    <div class="row justify-content-evenly">
                        <div class="col-6">
                        <span>
                            Prestataire à identifier :
                        </span>
                            <div class="mt-3">
                                <information-bloc
                                  :provider-id="providerWithoutGoogleSource ?providerWithoutGoogleSource.id : null"
                                  :vt-use="true">
                                </information-bloc>
                            </div>

                            <div class="mt-6">
                                <v-card class="bg-light text-dark">
                                    <v-card-text>
                                        <span>
                                           <v-icon color="primary" class="mb-2" left>lightbulb</v-icon>
                                            Conseils d'identification
                                        </span>
                                        <ul>
                                            <li>Vérifiez la correspondance du nom et de l'adresse</li>
                                            <li>Comparez les numéros de téléphone</li>
                                            <li>Consultez les avis et les notes si pertinent</li>
                                        </ul>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="d-flex">
                                <v-img src="/images/logo-GOOGLE.jpg"
                                       class="mr-5"
                                       width="100"
                                       max-width="20px"
                                       style="border-radius: 5px"
                                >
                                </v-img>
                                <span>
                                    Suggestions de pages :
                                </span>
                            </div>

                            <div v-if="proposedSources.length > 0">
                                <v-radio-group row class="mt-auto mb-auto"
                                               v-model="selectedSource">
                                    <div v-for="source in proposedSources" :key="source.google_id" class="mt-3">
                                        <div :class="{ 'border border-primary': selectedSource !== null &&
                                         selectedSource.google_id === source.google_id }">
                                            <vt-source-choice-card :source="source">
                                            </vt-source-choice-card>
                                        </div>
                                    </div>
                                </v-radio-group>
                            </div>

                            <div class="d-flex mt-3 justify-content-center">
                                <v-btn
                                  class="mr-3 bg-secondary text-white"
                                  @click="refuseSuggestions">
                                    <v-icon left>clear</v-icon>
                                    Aucune page ne correspond
                                </v-btn>

                                <v-btn
                                  class="default-button"
                                  @click="addSource"
                                  :disabled="selectedSource === null">
                                    <v-icon left>check</v-icon>
                                    Suivre cette page
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import InformationBloc from "../provider/summary/InformationBloc.vue"
import VtSourceChoiceCard from "./VtSourceChoiceCard.vue"

export default {
    name: "VtcGoogleSourceChoiceModal",
    components: { InformationBloc, VtSourceChoiceCard },
    data() {
        return {
            proposedSources: [],
            selectedSource: null,
        }
    },
    methods: {
        ...mapMutations("vtc", [
            "setSelectGoogleSourceModal",
            "setProviderWithoutGoogleSource",
        ]),
        getGoogleSources() {
            this.$global.loading = true

            this.$http.get("/veille-tourisme/admissibles-google-cards/" + this.providerWithoutGoogleSource.id).then((res) => {
                this.proposedSources = res.body.data.googleCards
                this.$global.loading = false
            })
        },
        cancel() {
            this.setProviderWithoutGoogleSource(null)
            this.proposedSources = []
            this.selectedSource = null
            this.setSelectGoogleSourceModal(false)
        },
        addSource() {
            this.$global.loading = true

            let payload = {
                url: this.selectedSource.url,
                googleId: this.selectedSource.google_id,
                providerId: this.providerWithoutGoogleSource.id,
            }

            this.$http.put("/veille-tourisme/add-google-source", payload).then((res) => {
                this.$global.loading = false
                this.cancel()
                this.$global.$emit("reload-vtc", "3")
            })
        },
        refuseSuggestions() {
            this.$global.loading = true

            let payload = {
                vtcId: this.vtc.id,
                providerId: this.providerWithoutGoogleSource.id,
                state: "NO_GOOGLE_SOURCE",
            }

            this.$http.put("/veille-tourisme/vtc/update_provider_state", payload).then((res) => {
                this.$global.loading = false
                this.cancel()
                this.$global.$emit("reload-vtc", "3")
            })
        },
    },
    computed: {
        ...mapState("vtc", [
            "providerWithoutGoogleSource",
            "vtc",
        ]),
    },
    watch: {
        providerWithoutGoogleSource() {
            if (this.providerWithoutGoogleSource !== null) {
                this.getGoogleSources()
            }
        },
    },
    created() {
        if (this.providerWithoutGoogleSource !== null) {
            this.getGoogleSources()
        }
    },
}
</script>